export default __webpack_public_path__ + "static/media/NSC Sample.157570fb.png";